module.exports = __webpack_public_path__ + "media/images/reCAPTCHA-logo@2x-cc6d2a2ebbdb4ca2d35c2a94f666e56c.png";